(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyPaymentLog', CompanyPaymentLog);

    CompanyPaymentLog.$inject = ['$resource', 'DateUtils'];

    function CompanyPaymentLog($resource, DateUtils) {
        var resourceUrl = 'api/company-payment-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
